import { Controller } from "@hotwired/stimulus"
import { createCredential, postJSON, supportsWebAuthn } from "../webauthn"

// Drives passkey registration on the security page: ask the server for
// creation options, create the credential on this device, then save it.
export default class extends Controller {
  static targets = ["button", "nickname", "error"]
  static values = { challengeUrl: String, createUrl: String }

  connect() {
    if (!supportsWebAuthn() && this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.title = "This browser doesn't support passkeys"
    }
  }

  async register(event) {
    event.preventDefault()
    this.clearError()
    this.setBusy(true)

    const nickname = this.hasNicknameTarget ? this.nicknameTarget.value : ""

    try {
      const options = await postJSON(this.challengeUrlValue)
      if (options.error) throw new Error(options.error)

      const credential = await createCredential(options)
      const result = await postJSON(this.createUrlValue, { credential, nickname })

      if (result.redirect) {
        window.location.href = result.redirect
      } else {
        throw new Error(result.error || "Could not add passkey.")
      }
    } catch (error) {
      if (error.name === "NotAllowedError" || error.name === "AbortError") {
        this.clearError() // user dismissed the prompt — stay silent
      } else {
        this.showError(error.message || "Could not add passkey.")
      }
      this.setBusy(false)
    }
  }

  setBusy(busy) {
    if (this.hasButtonTarget) this.buttonTarget.disabled = busy
  }

  showError(message) {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }

  clearError() {
    if (!this.hasErrorTarget) return
    this.errorTarget.textContent = ""
    this.errorTarget.classList.add("hidden")
  }
}
